import DurationUnit from './DurationUnit';

export default class Duration {

	private constructor (private quantity: number, private unit: DurationUnit) {
	}

	public static microseconds (quantity: number) {
		return new Duration(quantity, new DurationUnit(DurationUnit.MICROSECOND));
	}

	public static milliseconds (quantity: number) {
		return Duration.microseconds(quantity * 1000);
	}

	public static seconds (quantity: number) {
		return Duration.microseconds(quantity * 1000000);
	}

	public static minutes (quantity: number) {
		return Duration.microseconds(quantity * 60000000);
	}

	public static hours (quantity: number) {
		return Duration.microseconds(quantity * 3600000000);
	}

	public static days (quantity: number) {
		return Duration.microseconds(quantity * 86400000000);
	}

	public static weeks (quantity: number) {
		return Duration.microseconds(quantity * 604800000000);
	}

	public static months (quantity: number) {
		return new Duration(quantity, new DurationUnit(DurationUnit.MONTH));
	}

	public static quarters (quantity: number) {
		return Duration.months(quantity * 3);
	}

	public static years (quantity: number) {
		return Duration.months(quantity * 12);
	}

	public static decennia (quantity: number) {
		return Duration.months(quantity * 120);
	}

	public static centuries (quantity: number) {
		return Duration.months(quantity * 1200);
	}

	public static millenia (quantity: number) {
		return Duration.months(quantity * 12000);
	}

	public getMicroseconds () {
		if (this.unit.is(DurationUnit.MONTH)) {
			throw new Error('Invalid duration unit');
		}

		return this.quantity;
	}

	public getQuantity () {
		return this.quantity;
	}

	public getUnit () {
		return this.unit;
	}
}


// WEBPACK FOOTER //
// ./code/foundation/time/Duration.ts